import { SpotifyLogo, AppleLogo, Waveform } from "@phosphor-icons/react";

export const MUSIC_PLATFORMS = [
  { id: "spotify", icon: SpotifyLogo, name: "SPOTIFY", label: "Spotify", color: "#1DB954", placeholder: "https://open.spotify.com/artist/…" },
  { id: "applemusic", icon: AppleLogo, name: "APPLE MUSIC", label: "Apple Music", color: "#FA243C", placeholder: "https://music.apple.com/…/artist/…" },
  { id: "audiomack", icon: Waveform, name: "AUDIOMACK", label: "Audiomack", color: "#FFA200", placeholder: "username or https://audiomack.com/…" },
];

export const MUSIC_BY_ID = Object.fromEntries(MUSIC_PLATFORMS.map(p => [p.id, p]));

export const MusicListen = ({ items, cardClass = "" }) => {
  const music = items.filter(s => MUSIC_BY_ID[s.platform]);
  if (!music.length) return null;
  return (
    <div className={`col-span-6 border border-white/10 bg-black/40 p-6 ${cardClass}`} data-testid="bio-music-section">
      <div className="text-xs font-mono-k tracking-widest-k text-white/60 mb-4">— LISTEN NOW</div>
      <div className="grid sm:grid-cols-3 gap-2">
        {music.map(s => {
          const p = MUSIC_BY_ID[s.platform];
          return (
            <a key={s.platform} href={s.profile_url} target="_blank" rel="noreferrer"
              className={`flex items-center gap-3 border p-3 transition-transform duration-150 hover:-translate-y-0.5 ${cardClass}`}
              style={{ borderColor: p.color + "80", background: p.color + "14" }}
              data-testid={`bio-music-${s.platform}`}>
              <p.icon size={26} weight="fill" style={{ color: p.color }} />
              <div className="min-w-0">
                <div className="text-sm font-medium">{p.label}</div>
                <div className="text-[10px] font-mono-k text-white/60 truncate">Stream on {p.label}</div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};
